// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"5234ba0b","455":"cc1aee01","977":"c2fe5f81"}[chunkId] + ".chunk.js";
};